import {clsx} from 'clsx'
import type {ComponentProps} from 'react'

import styles from './card-base.module.css'

type CardBaseProps = ComponentProps<'div'> & {ref?: React.Ref<HTMLDivElement>}

export const CardBase = ({ref, className, ...props}: CardBaseProps) => (
  <div className={clsx(className, styles.CardBase)} {...props} ref={ref} />
)
CardBase.displayName = 'CardBase'
